module.exports = __webpack_public_path__ + "static/img/T2.3543553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/T2.png
// module id = ToDg
// module chunks = 1